// 处理手动置顶工单
import { getStorage, setStorage } from '@/utils/auth'
import { computed } from 'vue'
import store from '@/store/index'

const topKey = 'TOP_LIST'
export default function useTopUp() {
  const erpId = computed(() => store.getters.userInfo.erpId)
  const chartId = computed(() => store.state.workOrder.chartId)

  const getTopList = () => {
    const obj = getStorage(topKey) || {}
    return obj[erpId.value] || []
  }
  const setTopList = data => {
    const obj = getStorage(topKey) || {}
    obj[erpId.value] = data
    setStorage(topKey, obj)
  }
  // 工单回滚、完成之后需要移除置顶
  const removeTopList = id => {
    if (!id) return
    const list = getTopList()
    const index = list.findIndex(it => it === id)
    if (index > -1) {
      list.splice(index, 1)
      setTopList(list)
    }
  }
  // 新增置顶
  const addTopList = id => {
    const list = getTopList()
    list.push(id)
    setTopList(list)
  }
  // 工单回滚/完成之后需要将置顶工单回收
  const recoverTopList = () => {
    removeTopList(chartId.value)
  }
  // 切换坐班状态将所有置顶信息回收
  const recoverAllTopList = () => {
    setTopList([])
  }
  return {
    getTopList,
    setTopList,
    removeTopList,
    addTopList,
    recoverTopList,
    recoverAllTopList
  }
}
